import * as Mutations from './mutations';
import { TShirtsService } from '../../../common/services/settings/t-shirts.service';

export const TShirtsModule = {
    state: {
        tShirts: []
    },
    mutations: {
        [Mutations.SET_T_SHIRTS](state, tShirts) {
            state.tShirts = tShirts;
        }
    },
    actions: {
        async getTShirts(context) {
            const { data } = await TShirtsService.getTShirts(context.getters.schoolId);

            const sizeOrder = [
                    "YXS",
                    "YS",
                    "YM",
                    "YL",
                    "YXL",
                    "XS",
                    "S",
                    "M",
                    "L",
                    "XL",
                    "XXL"
                 ];

            const sortedSizes = data.sort((a, b) => sizeOrder.indexOf(a.size) - sizeOrder.indexOf(b.size));     

            context.commit(Mutations.SET_T_SHIRTS, sortedSizes);
        },
        async toggleTShirtStatus(context, sizeId) {
            await TShirtsService.toggleTShirtStatusStatus(context.getters.schoolId, sizeId);
            context.dispatch('resetFilter');
            await context.dispatch('getTShirts');
        }
    },
    getters: {
        tShirts: (state, getters, rootState, rootGetters) => {
            let tShirts = state.tShirts;
            if (rootGetters.filters && rootGetters.filters.active !== null) {
                tShirts = state.tShirts.filter(tShirt =>
                    tShirt.status === rootGetters.filters.active)
            }
            if (rootGetters.searchQuery && rootGetters.searchQuery.length) {
                tShirts = tShirts.filter(tShirt =>
                    tShirt.size
                        .toLowerCase()
                        .includes(rootGetters.searchQuery.toLowerCase()
                        ));
            }
            return tShirts;
        },

        tShirtsBasic: state => state.tShirts,

        tShirtsSizes: state => state.tShirts.map(tShirt => tShirt.size)
    }
};


// WEBPACK FOOTER //
// ./src/store/modules/t-shirts/t-shirts.module.js